import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './ui/dialog';
import { Button } from './ui/button';
import { Target, CheckCircle2 } from 'lucide-react';

const ObjetivosPontuaisLembrete = ({ isOpen, onClose, onGoToObjetivos }) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[500px]">
        <DialogHeader>
          <div className="flex items-center gap-2 mb-2">
            <Target className="h-6 w-6 text-blue-600" />
            <DialogTitle className="text-xl">Tem Objetivos Pontuais Ativos!</DialogTitle>
          </div>
          <DialogDescription className="text-base space-y-3 pt-2">
            <p>
              Acabou de registar uma venda. Tem objetivos pontuais ativos que podem estar relacionados.
            </p>
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 my-3">
              <div className="flex items-start gap-3">
                <CheckCircle2 className="h-5 w-5 text-blue-600 flex-shrink-0 mt-0.5" />
                <div className="text-sm text-gray-700">
                  <p className="font-medium text-gray-900 mb-1">Não se esqueça:</p>
                  <p>Se esta venda contribui para algum dos seus objetivos pontuais, registe o progresso para ganhar pontos!</p>
                </div>
              </div>
            </div>
            <p className="text-sm text-gray-600">
              Quer ir para a aba <span className="font-semibold">Meus Objetivos</span> para registar o progresso?
            </p>
          </DialogDescription>
        </DialogHeader>
        <div className="flex gap-3 mt-4">
          <Button 
            variant="outline" 
            onClick={onClose}
            className="flex-1"
          >
            Agora Não
          </Button>
          <Button 
            onClick={onGoToObjetivos}
            className="flex-1 bg-blue-600 hover:bg-blue-700"
          >
            Ir para Objetivos
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ObjetivosPontuaisLembrete;
